import { useState, useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const useDeviceFingerprint = () => {
  const [visitorId, setVisitorId] = useState(null);

  useEffect(() => {
    const getFingerprint = async () => {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        setVisitorId(result.visitorId);
      } catch (error) {
        console.error('Error generating fingerprint:', error);
        // Fallback to a random UUID if fingerprint fails
        const fallbackId = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substring(2);
        setVisitorId(fallbackId);
      }
    };
    getFingerprint();
  }, []);

  return visitorId;
};

export default useDeviceFingerprint;